import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { tablesDummyData } from "./tablesDummyData";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Skeleton } from "primereact/skeleton";
import { Button } from "primereact/button";
import "./Charger.css";
import DeleteModal from "../../components/modals/DeleteModal";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { Ripple } from "primereact/ripple";
import { classNames } from "primereact/utils";
import AddChargerModal from "../../components/modals/AddChargerModal";
import AddAgencyModalLogo from "../../assets/images/addAgencyModalLogo.svg";
import { connect, useDispatch, useSelector } from "react-redux";
import EditChargerModal from "../../components/modals/editModals/EditChargerModal";
import { CHARGER_TECHNOLOGY } from "../../constants/constant.data";
import {
  deleteCharger,
  exportCharger,
  getAllChargers,
  uploadChargersFile,
} from "../../services/chargers.service";
import { CommonDropdown } from "../../components/common-input";
import { Paginator } from "primereact/paginator";
import { getAgenciesWOL } from "../../services/agency.service";
import { agenciesSuccess } from "../../redux/agencies.slice";
import useToast from "../../context/toast.hook";
import { Toast } from "primereact/toast";
import { handleDownloadFileTemplate, handleExport } from "../../helpers/utils";
import moment from "moment";
import CommonBackdrop from "../../components/loader";

const ChargerPage = (props) => {
  const [showBackdrop, setShowBackdrop] = React.useState(false);

  const [sortMeta, setSortMeta] = useState({ sortField: "", sortOrder: "" });
  const hiddenFileInput = React.useRef(null);
  const { errorToast, successToast, toastRef } = useToast();
  const dispatch = useDispatch();
  const { allAgencies } = useSelector((state) => state.agencies);
  const { currentUser } = useSelector((state) => state.user);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [deleteProductDialog, setDeleteProductDialog] = useState(false);
  const [chargers, setChargers] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [positonRight, setPositonRight] = useState("220px");
  const [toggleAddModal, setToggleAddModal] = useState(false);
  const [toggleEditModal, setToggleEditModal] = useState(false);
  const [tableFilter, setTableFilter] = useState("");
  const [page, setPage] = useState(1);
  const [selectedCharger, setSelectedCharger] = useState("");
  const [first, setFirst] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "country.name": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "representative.name": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    company: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });
  let position;

  if (width > 950) {
    position = "255px";
  } else {
    position = "225px";
  }

  const template2 = {
    layout: "CurrentPageReport PrevPageLink PageLinks NextPageLink",
    CurrentPageReport: (options) => {
      return (
        <div className="mobileHideShowing">
          <span
            style={{
              color: "var(--text-color)",
              userSelect: "none",
              width: "160px",
              textAlign: "center",
            }}
          >
            Showing {options.first} - {options.last} of {options.totalRecords}
          </span>
        </div>
      );
    },
    PrevPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">{"<"}</span>
          <Ripple />
        </button>
      );
    },
    PageLinks: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">{">"}</span>
          <Ripple />
        </button>
      );
    },
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const handleGetChargers = (currentPage, sorting) => {
    let filters = sorting
      ? {
          ...tableFilter,
          sortField: sorting.sortField,
          sortOrder: sorting.sortOrder,
        }
      : {
          ...tableFilter,
          sortField: sortMeta.sortField,
          sortOrder: sortMeta.sortOrder,
        };
    setLoading(true);
    getAllChargers({
      page: currentPage || page,
      limit: 10,
      filters,
    })
      .then((res) => {
        setChargers(res?.data?.chargers);
        setTotalCount(res?.data?.totalCount);
        setLoading(false);
      })
      .catch((err) => {
        errorToast(err);
        setLoading(false);
      });
  };

  const getAllAgencies = () => {
    getAgenciesWOL()
      .then((res) => {
        dispatch(agenciesSuccess(res?.data?.data));
      })
      .catch((error) => {
        errorToast(error);
      });
  };
  useEffect(() => {
    handleGetChargers();
    getAllAgencies();
  }, []);

  const handleChargerAdded = (onlyModalClose) => {
    if (onlyModalClose) {
      setToggleAddModal(false);
      return;
    }
    successToast("Charger added successfully");
    setToggleAddModal(false);
    setPage(1);
    setSelectedCharger("");
    handleGetChargers(1);
  };

  const exportData = async () => {
    const result = await exportCharger();
    handleExport(result, "Chargers.csv");
  };

  const renderHeader = () => {
    return (
      <div className="headerButtons">
        <div className="startButtons">
          {currentUser?.role === "admin" && (
            <div className="selectBoxCharger">
              <CommonDropdown
                name="agencyId"
                optionArray={allAgencies}
                optionKey="_id"
                optionLabel="name"
                placeholder="Select Agency"
                label="Agency"
                isSelectAll
                style={{ height: "40px" }}
                onChange={(e) =>
                  setTableFilter({
                    ...tableFilter,
                    agencyId: e.target.value,
                  })
                }
                value={tableFilter?.agencyId}
              />
            </div>
          )}

          <div className="selectBoxCharger">
            <CommonDropdown
              placeholder="Technology"
              onChange={(e) =>
                setTableFilter({
                  ...tableFilter,
                  technology: e.target.value,
                })
              }
              value={tableFilter?.technology}
              isSelectAll
              optionArray={CHARGER_TECHNOLOGY}
              optionKey="key"
              optionLabel="key"
              style={{ height: "40px" }}
              label="Technology"
            />
          </div>
          <div className="applyButton">
            <Button
              style={{
                backgroundColor: "#1C9894",
                color: "white",
                border: "0",
                width: "120%",
                textAlign: "center",
                fontStyle: "normal",
                fontWeight: "normal",
              }}
              label="Apply"
              onClick={() => {
                setPage(1);
                handleGetChargers(1);
              }}
              placeholder="Apply"
            />
          </div>
        </div>
        <div className="endButtons">
          <div className="exportButtonCharger">
            <Button
              style={{
                backgroundColor: "#1C9894",
                color: "white",
                border: "0",
              }}
              onClick={exportData}
              placeholder="Export Data "
              label="Export Data"
            />
          </div>
        </div>
      </div>
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div style={{ display: "flex", gap: "5px" }}>
        <Button
          icon="pi pi-pencil"
          className="p-button-outlined p-button-icon-only mr-2"
          width="2rem"
          onClick={() => {
            setSelectedCharger(rowData);
            setToggleEditModal(true);
          }}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-danger p-button-outlined p-button-icon-only"
          onClick={() => {
            setSelectedCharger(rowData);
            setDeleteProductDialog(true);
          }}
        />
      </div>
    );
  };

  const header = renderHeader();

  const handleConfirmDelete = async () => {
    deleteCharger(selectedCharger?._id)
      .then((res) => {
        successToast(res?.data?.message);
        setDeleteProductDialog(false);
        setPage(1);
        handleGetChargers(1);
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const handleChargerUpdated = (onlyModalClose) => {
    if (onlyModalClose) {
      setToggleEditModal(false);
      setSelectedCharger("");
      return;
    }
    successToast("Charger updated successfully");
    setToggleEditModal(false);
    setSelectedCharger("");
    handleGetChargers();
  };

  const onPageChange = (event) => {
    setPage(event.page + 1);
    setFirst(event.first);
    handleGetChargers(event.page + 1);
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleImportChargers = (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    setShowBackdrop(true);
    hiddenFileInput.current.value = null;
    uploadChargersFile(formData)
      .then((res) => {
        successToast(res.data?.message, "Chargers imported");
        setShowBackdrop(false);
        setPage(1);
        handleGetChargers(1);
      })
      .catch((err) => {
        setShowBackdrop(false);
        errorToast(err);
      });
  };

  const dateBodyTemplate = (rowData) => {
    return rowData.serviceStartedAt
      ? moment.utc(rowData.serviceStartedAt).format("YYYY")
      : "N/A";
  };
  const handleSort = async (e) => {
    setSortMeta({
      sortField: e.sortField,
      sortOrder: e.sortOrder,
    });
    setPage(1);
    setFirst(0);
    handleGetChargers(1, {
      sortField: e.sortField,
      sortOrder: e.sortOrder,
    });
  };
  return (
    <>
      <CommonBackdrop showBackdrop={showBackdrop} />
      <Toast ref={toastRef} />
      {toggleAddModal && <AddChargerModal toggleModal={handleChargerAdded} />}
      {toggleEditModal && (
        <EditChargerModal
          chargerData={selectedCharger}
          toggleModal={handleChargerUpdated}
        />
      )}
      <div className="initialBox">
        <div className="welcomeBox">
          <strong>All Chargers</strong>
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
          }}
        >
          <Button
            icon="pi pi-download"
            label="Sample File"
            style={{ width: "140px", border: "0", whiteSpace: "nowrap" }}
            onClick={() => handleDownloadFileTemplate("chargers", "charger")}
          />
          <Button
            icon="pi pi-upload"
            label="Import Chargers"
            style={{ width: "160px", border: "0", whiteSpace: "nowrap" }}
            onClick={handleClick}
          />

          <input
            ref={hiddenFileInput}
            style={{ display: "none" }}
            multiple="false"
            onChange={handleImportChargers}
            type="file"
            name="fileUpload"
            id="fileUpload"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />

          <Button
            style={{
              backgroundColor: "#1C9894",
              color: "white",
              border: "0",
              width: "172px",
              height: "41px",
            }}
            placeholder="Add Agency "
            label="Add New Charger"
            onClick={() => {
              setToggleAddModal(true);
            }}
          />
        </div>
      </div>

      {!loading && (
        <DataTable
          value={chargers}
          stripedRows
          responsiveLayout="scroll"
          selectionMode="single"
          onSelectionChange={(e) => setSelectedProducts(e.value)}
          dataKey="id"
          header={header}
          filters={filters}
          emptyMessage="No Record found."
          sortField={sortMeta.sortField}
          sortOrder={sortMeta.sortOrder}
          sortMode="single"
          onSort={handleSort}
        >
          {currentUser?.role === "admin" && (
            <Column
              field="agencyId.name"
              header="Agency"
              style={{ backgroundColor: "" }}
            />
          )}

          <Column field="chargerNumberPlate" header="Charger No" sortable />
          <Column
            field="chargerManufacturer"
            header="Manufactured by"
            sortable
          />
          <Column
            field="serviceStartedAt"
            header="Model Year"
            sortable
            body={dateBodyTemplate}
          />
          <Column field="technology" header="Technology" sortable />
          <Column field="efficiency" header="Efficiency (%)" sortable />
          <Column field="apparentPower" header="Power Rating (kVA)" sortable />
          {/* <Column field="busLength" header="Bus Length (ft)" sortable /> */}
          <Column header="Actions" body={actionBodyTemplate} />
        </DataTable>
      )}
      <br />
      <Paginator
        first={first}
        template={template2}
        rows={10}
        totalRecords={totalCount}
        rowsPerPageOptions={[10, 20, 30]}
        onPageChange={onPageChange}
      />
      {loading && <Skeleton height="28rem" />}

      {deleteProductDialog && (
        <DeleteModal
          deleteProductDialog={deleteProductDialog}
          onHide={() => {
            setSelectedCharger("");
            setDeleteProductDialog(false);
          }}
          onConfirm={handleConfirmDelete}
          customMessage="Associated transit data will also be deleted, are you sure you want to delete this charger?"
        />
      )}
    </>
  );
};

export default ChargerPage;
